import 'lazysizes/plugins/object-fit/ls.object-fit';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import 'lazysizes/plugins/rias/ls.rias';
import 'lazysizes/plugins/bgset/ls.bgset';
import 'lazysizes';
import 'lazysizes/plugins/respimg/ls.respimg';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';
import videojs from 'video.js';

import barba from '@barba/core';

// Components
import './components/page-transitions';
import './components/hero-slider';
import carousel from './components/carousel';
import process from './components/process';
import menu from './components/menu';
import cursor from './components/cursor';
import bgTransition from './components/background-transition';

document.addEventListener('DOMContentLoaded', () => {
	menu.init();
	carousel.init();
	process.init();
	cursor.init();
	bgTransition.init();
});

barba.hooks.beforeEnter(() => {
	carousel.init();
	process.init();
	cursor.init();
	bgTransition.init();
	if (document.querySelectorAll('.video-js')) {
		const videos = Array.from(document.querySelectorAll('.video-js'));
		videos.forEach((video) => {
			videojs(video);
		});
	}
});
